// Modules
import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'

// Components
import AppleIdentity from './components/apple-identity/AppleIdentity'
import GoogleIdentity from './components/google-identity/GoogleIdentity'

// Hooks
import useLanguage from 'hooks/system/useLanguage'

// Styles
import './ProviderButton.scss'

// Data (Local)
const providersData = {
	apple: {
		component: AppleIdentity,
		name: 'Apple'
	},
	google: {
		component: GoogleIdentity,
		name: 'Google'
	}
}

// Component: External > Provider button
function ProviderButton ({ className, isDisabled, isInitialized, onResponse, provider, style, type }) {
	// State

	// Data
	const { translate } = useLanguage('components.external.providerButton')

	// Data (Memoized)
	const providerData = useMemo(() => providersData[provider], [provider])

	// Functions
	function renderProviderInteraction () {
		const ProviderInteraction = providerData.component
		return (
			<ProviderInteraction
				type={type}
				className="aix-hidden"
				isDisabled={isDisabled}
				isInitialized={isInitialized}
				onResponse={onProviderResponse} />
		)
	}

	// Functions (Memoized)
	const onProviderResponse = useCallback(response => onResponse(response, provider), [onResponse, provider])

	// Render
	if (!isInitialized || !providerData) return null
	return (
		<span
			data-external="provider-button"
			className={
				'aix-provider-button aix-paper' +
				(isDisabled ? ' aix-disabled' : '') +
				(className ? ` ${className}` : '')
			}
			style={style}>
			<div className="aix-disguise">
				<img
					className="aix-icon"
					src={`/images/external/symbol-${provider}.svg`} />
				<span className="aix-text">{translate.local(`${type}WithProvider`, { provider: providerData.name })}</span>
			</div>
			{renderProviderInteraction()}
		</span>
	)
}

// Properties
ProviderButton.propTypes = {
	className: PropTypes.string,
	isDisabled: PropTypes.bool,
	isInitialized: PropTypes.bool.isRequired,
	onResponse: PropTypes.func.isRequired,
	provider: PropTypes.oneOf(['apple', 'google']).isRequired,
	style: PropTypes.object,
	type: PropTypes.oneOf(['continue', 'signUp', 'signIn'])
}

// Export
export default ProviderButton
